export default __webpack_public_path__ + "static/media/CroboCopNFT.35d6fe84.gif";